import styled from 'styled-components';

export const Step = styled.div`
  display: flex;
  border-left: 1px dashed ${({ isEnd = false }) => (isEnd ? '#fff' : '#cfd7df')};
  position: relative;
  flex-direction: column;

  ${({ disabled }) => disabled && 'opacity: 0.5;'}

  .title {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: var(--base-color);
    padding-left: 30px;
    margin-bottom: 8px;
  }

  .helptext {
    padding-left: 30px;
  }

  .content {
    padding: 20px 30px;
    padding-right: 0;

    .alert-message {
      margin-left: 10px;
      border-left: 2px solid #fddbb5;
      padding-left: 10px;
      font-size: 14px;
      line-height: 20px;
      color: #475867;
    }
    .message {
      padding: 8px 12px;
      background-color: #fef1e1;
      margin: 12px 0;
      [data-testid='close-button'] {
        top: 20px;
        width: 15px;
        height: 15px;
      }
    }

    .highlight {
      color: #1f9999;
      font-weight: 500;
      font-size: 12px;
      line-height: 14px;
    }
  }

  &:before {
    content: '';
    display: block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border: 1px solid ${({ disabled }) => (disabled ? '#cfd7df' : '#1F9999')};
    position: absolute;
    left: -8px;
    top: 0px;
    background-color: ${({ completed }) => (completed ? '#1F9999' : '#fff')};
  }

  .icon {
    position: absolute;
    width: 15px;
    height: 15px;
    left: -4px;
    top: -5px;
  }

  button.submit {
    width: fit-content;
    margin-left: 30px;
  }
`;

export const Adornment = styled.div<{ position?: string }>`
  background: #f6f6f6;
  ${({ position }) =>
    position === 'start'
      ? 'border-right: 1px solid #cfd7df;'
      : 'border-left: 1px solid #cfd7df;'}
  font-size: 12px;
  line-height: 14px;
  color: #4b5165;
  padding: 10px 12px;
  border-top-left-radius: ${({ position }) =>
    position === 'start' ? '4px' : '0'};
  border-bottom-left-radius: ${({ position }) =>
    position === 'start' ? '4px' : '0'};
  border-top-right-radius: ${({ position }) =>
    position === 'start' ? '0' : '4px'};
  border-bottom-right-radius: ${({ position }) =>
    position === 'start' ? '0' : '4px'};
`;

export const CustomDomainForm = styled.div`
  width: 100%;
  max-width: 700px;
  label {
    text-transform: unset !important;
  }
  :not(:last-child) {
    margin-bottom: 36px;
  }

  .removebtn {
    color: #e43538;
    &:hover {
      background: none;
    }
  }

  .inline {
    max-width: 800px;
    display: flex;
    align-items: baseline;
  }

  .inline-success {
    max-width: 800px;
    display: flex;
    align-items: baseline;
    padding-left: 24px;
  }
  .end-adornment {
    a {
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      color: #375de6;
      padding: 7px 14px;
      background: #fafafa;
      border-bottom-right-radius: 4px;
      border-top-right-radius: 4px;
    }
  }
`;

export const CopyContent = styled.div<any>`
  display: flex;
  flex-direction: column;
  width: ${({ width }) => (width ? width : '50%')};

  .copy-label {
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    color: var(--base-color);
    margin-bottom: 1rem;
  }

  .copy-box {
    border: ${({ border }) => border || '1px dashed #aac0ef'};
    box-sizing: border-box;
    border-radius: 4px;
    padding: 8px 12px;
    display: flex;
    justify-content: space-between;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    color: #12344d;
    align-items: center;
    background: ${({ background }) => background || 'transparent'};

    .copy-box-text {
      white-space: nowrap;
      overflow: hidden;
      max-width: 75%;
    }
  }
`;
